export enum WorkspaceTemplateCategory {
	EDUCATION = 'EDUCATION',
	HOBBIES = 'HOBBIES',
	HOME = 'HOME',
	WORK = 'WORK',
	OTHERS = 'OTHERS',
}
